import { styled } from "@mui/material";
import { tokens } from "@styles/tokens";

/** Design-system surface: rounded card with a soft shadow. */
export const Card = styled("div")(({ theme }) => ({
  backgroundColor: theme.skuey.surface,
  borderRadius: tokens.radius.xl,
  boxShadow: tokens.shadow.lg,
  border: `1px solid ${theme.skuey.border}`,
}));
